import React, { useEffect } from "react";
import Result from "./result";

const Results = ({ resourcedTexts, offices, searchTerm, selected, toggleSelected }) => {
  if (!offices.length) {
    return null;
  }

  return (
    <div className="business-locator__overlay">
      {offices.map((office) => {
        return (
          <Result
            resourcedTexts={resourcedTexts}
            office={office}
            searchTerm={searchTerm}
            key={office.id}
            selected={selected}
            toggleSelected={toggleSelected}
          />
        );
      })}
    </div>
  );
};

export default Results;
